let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gryT8"), load("b8oHe")]).then(() => parcelRequire('1Q21q'));